import { Column, ICellFormatter } from "@syncfusion/ej2-angular-grids";
import { RightsApprovalStatusEnum } from "src/app/api";

export class RightsFormatterApprovalStatus implements ICellFormatter {
  getValue(column: Column, data: Object): Object {
    var rowData: any = data;
    if (!rowData) {
      return '';
    }
    var status : RightsApprovalStatusEnum = rowData.approvalStatus;
    var statusList : any[] = (<any> column.dataSource).dataSource.json;
    var statusText : string = statusList.find(s => s.id == status).name;
        
    var cls: string = ''
    switch (status) {
      case RightsApprovalStatusEnum.None:
        cls = '';//'e-primary';
        break;
      case RightsApprovalStatusEnum.Approved:
        cls = 'e-success';
        break;
      case RightsApprovalStatusEnum.Rejected:
        cls = 'e-danger'; 
        break
      case RightsApprovalStatusEnum.ApprovedAndCloseContract:
        cls = "e-warning"; 
        break
    }
    return '<div class="e-chip-list"><div class="e-chip ' + cls + '"><div class="e-chip-text">' + statusText + '</div></div></div>';
  }
}
